import { withPrefix } from 'gatsby';

import { sanitizeSlug } from '../../utils/sanitizeSlug';

export const getCanonical = (value: string): string => {
  const canonical =
    value && value.startsWith('https://')
      ? value
      : `https://img.ly${withPrefix(value)}`;

  return sanitizeSlug(canonical);
};
